(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidIndividualDialogController', CovidIndividualDialogController);

    CovidIndividualDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CovidIndividual', 'CovidSignature'];

    function CovidIndividualDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CovidIndividual, CovidSignature) {
        var vm = this;

        vm.covidIndividual = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.covidsignatures = CovidSignature.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.covidIndividual.id !== null) {
                CovidIndividual.update(vm.covidIndividual, onSaveSuccess, onSaveError);
            } else {
                CovidIndividual.save(vm.covidIndividual, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:covidIndividualUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dob = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
